import {Component, Input, OnInit} from '@angular/core';
import {Report} from '../../model/report';
import {User} from '../../model/user';
import {Router} from '@angular/router';
import {CommonService} from '../../common/common.service';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {LoaderService} from "../spinner/loader.service";

@Component({
  selector: 'pbc-suggester-vertical',
  templateUrl: './suggester-vertical.component.html',
  styleUrls: ['./suggester-vertical.component.scss']
})
export class SuggesterVerticalComponent implements OnInit {

  @Input() isLimited:boolean = false;
  suggestedReports : Array<Report> = [];
  private loggedUser : User;
  private static readonly sortString = 'publishFrom DESC';

  constructor(private router : Router,
              private commonService : CommonService,
              private notifierService : NotifierService,
              public loaderService : LoaderService
              ) { }

  ngOnInit() {
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loggedUser = authData.user;

    if (this.loggedUser.id)
      this.getSuggestedReports();
  }

  private getSuggestedReports() {
    this.commonService.getSuggestedReports(SuggesterVerticalComponent.sortString).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można pobrać sugerowanych raportów");
        else {
          if(this.isLimited){
            if( result.record){
              if( result.record.length>4){
                result.record.splice(3,  result.record.length-4);
              }
            }
          }
          this.suggestedReports = result.record;
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie można pobrać sugerowanych raportów");
      }
    )
  }

  onClickOnSuggestedReport(reportId : number) {
    this.moveToTop();
    this.commonService.registerClickOnElement('suggestedReportClick',
      'suggesterVertical', 'report', reportId).subscribe(
        success=>{
        if (success.status != 1)
          console.log(success.message);
        },
      error => {
        console.log(error);
      }
    );
  }

  private moveToTop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

}
